import { Suspense, lazy } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import SuspenseLoader from 'src/components/SuspenseLoader';
import ReceptionStepper from 'src/components/ReceptionStepper';

export const Loader = (Component) => (props) =>
(
    <Suspense fallback={<SuspenseLoader />}>
        <Component {...props} />
    </Suspense>
);

const Reception = Loader(lazy(() => import('src/content/reception/client')));
const CheckIn = Loader(lazy(() => import('src/content/reception/checkin')));
const Payment = Loader(lazy(() => import('src/content/reception/payment')));
const Report = Loader(lazy(() => import('src/content/reception/report')));
const Reports = Loader(lazy(() => import('src/content/reception/reports')));
const Transactions = Loader(lazy(() => import('src/content/reception/transactions')));

const ReceptionLayout = () => (
    <>
        <ReceptionStepper />
        <Outlet />
    </>
);

const receptionRoutes = [
    {
        path: '',
        element: <ReceptionLayout />,
        children: [
            {
                path: '',
                element: <Navigate to="register" replace />
            },
            {
                path: 'register',
                element: <Reception />
            },
            {
                path: 'check-in',
                element: <CheckIn />
            },
            {
                path: 'payment',
                element: <Payment />
            },
            {
                path: 'transactions',
                element: <Transactions />
            },
            {
                path: 'report',
                element: <Report />
            },
            {
                path: 'reports',
                element: <Reports />
            },
        ]
    }
];

export default receptionRoutes;
